/// <reference types="./italic.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function italic() {
  return $svg.square(
    20,
    "<path d=\"M12.5 17.292H5.83331V15.6253H8.27215L10.0354 5.62528H7.49998V3.95862H14.1666V5.62528H11.7278L9.96456 15.6253H12.5V17.292Z\" fill=\"currentColor\"/>",
  );
}
